/* Snus Cambodia product cards (site-wide): Buy now + Add to cart, and the sc-rail slider */
(() => {
  if (window.__scgBound) return; window.__scgBound = true;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const txt = (btn) => btn.querySelector('.scg-btn__txt') || btn.querySelector('span');
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-scg-add]');
    if (!form) return;
    e.preventDefault();
    const btn = e.submitter && form.contains(e.submitter) ? e.submitter : form.querySelector('[data-action="add"]');
    const action = btn.dataset.action || 'add';
    const label = txt(btn);
    const original = label ? label.textContent : '';
    const setLabel = (t) => { if (label) label.textContent = t; };
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    btn.classList.remove('is-error');
    try {
      const fd = new FormData();
      fd.append('id', form.querySelector('[name="id"]').value);
      fd.append('quantity', '1');
      const sections = action === 'add' ? [...document.querySelectorAll('cart-items-component[data-section-id]')].map((el) => el.dataset.sectionId) : [];
      if (sections.length) { fd.append('sections', sections.join(',')); fd.append('sections_url', window.location.pathname); }
      const res = await fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add');
      if (action === 'buy') {
        setLabel('Checkout…');
        window.location.href = root + 'checkout';
        return;
      }
      const ev = new Event('cart:update', { bubbles: true });
      ev.detail = { resource: {}, sourceId: String(fd.get('id')), data: { source: 'product-form-component', itemCount: 1, productId: btn.dataset.productId, sections: data.sections } };
      document.dispatchEvent(ev);
      btn.classList.add('is-added'); setLabel('Added');
      btn.setAttribute('aria-label', 'Added to cart');
      setTimeout(() => { btn.classList.remove('is-added'); setLabel(original); btn.setAttribute('aria-label', 'Add to cart'); }, 2200);
    } catch (err) {
      btn.classList.add('is-error');
      btn.title = (err && err.message) ? err.message : 'Try again';
      setLabel((err && err.message) ? err.message.slice(0, 22) : 'Try again');
      setTimeout(() => { btn.classList.remove('is-error'); setLabel(original); btn.title = 'Add to cart'; }, 2600);
    } finally {
      btn.removeAttribute('aria-busy');
    }
  });

  if (!customElements.get('sc-rail')) {
    customElements.define('sc-rail', class extends HTMLElement {
      connectedCallback() {
        this.vp = this.querySelector('.scr__viewport');
        this.arrows = [...this.querySelectorAll('.scr__arrow')];
        if (!this.vp) return;
        this.arrows.forEach((b) => b.addEventListener('click', () => {
          const item = this.vp.querySelector('.scr__item');
          const step = item ? item.getBoundingClientRect().width + 12 : 240;
          const n = Math.max(1, Math.floor(this.vp.clientWidth / step));
          this.vp.scrollBy({ left: Number(b.dataset.dir) * n * step, behavior: 'smooth' });
        }));
        this.update = () => {
          const max = this.vp.scrollWidth - this.vp.clientWidth - 2;
          if (this.arrows[0]) this.arrows[0].disabled = this.vp.scrollLeft <= 2;
          if (this.arrows[1]) this.arrows[1].disabled = this.vp.scrollLeft >= max;
          this.classList.toggle('is-static', max <= 0);
        };
        this.vp.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        this.update();
      }
    });
  }
})();
